function Services() {
    const services = [
      { title: "Diş Estetiği", description: "Beyazlatma, implant ve daha fazlası." },
      { title: "Cilt Bakımı", description: "Anti-aging, gençlik aşısı uygulamaları." },
      { title: "Saç Ekimi", description: "Modern yöntemlerle saç ekimi." },
    ];
  
    return (
      <div className="py-5">
        <div className="container">
          <h2 className="text-center mb-5">Hizmetlerimiz</h2>
          <div className="row">
            {services.map((service, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="card h-100 shadow-sm text-center">
                  <div className="card-body">
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  
  export default Services;